export default {
    PIX: 1,
    CREDIT_CARD: 2,
    DISCOUNT: 3,
    FREE: 4,
    CHECKOUT: 5,
}